<app-error-modal
  *ngIf="showModal"
  [title]="title"
  [subtitle]="subtitle"
  [typeIcon]="typeIcon"
  [buttonRight]="buttonRight"
  [isCloseable]="false"
  (selectedOption)="onSelectedOption($event)">
</app-error-modal>
